import { connect } from 'react-redux';
import { logoutUser } from '../thunks/userAuthThunks.js';
import App from '../app/App.jsx';
import get from 'lodash/get.js';

const mapStateToProps = ({ user, router, general }) => {
    return {
        location: router.location,
        userId: get(user, 'user.id', 0),
        userFirstName: get(user, 'user.firstName', ''),
        userLastName: get(user, 'user.lastName', ''),
        permissions: get(user, 'permissions', {}),
        isAuthenticated: Boolean(user.token && user.user.id),
        settings: general.settings,
        initialized: user.initialized,
    };
};

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
